export interface EvmBridgersTransactionData {
    data: string;
    to: string;
    value: string;
}
